
// import React, { useState, useEffect } from "react";
// import {
//   Select,
//   Button,
//   Card,
//   Typography,
//   Table,
//   message,
//   Spin,
//   Tabs,
// } from "antd";
// import {
//   SendOutlined,
//   BarChartOutlined,
//   LineChartOutlined,
//   FileTextOutlined,
// } from "@ant-design/icons";
// import {
//   BarChart,
//   Bar,
//   LineChart,
//   Line,
//   CartesianGrid,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   LabelList,
// } from "recharts";
// import ApiService from "../EOLReportApi/ReportApiService";
// import "antd/dist/reset.css";
// import { motion, AnimatePresence } from "framer-motion";


// const { Option } = Select;
// const { Title } = Typography;
// const { TabPane } = Tabs;

// const AnimatedCounter = ({ value }) => {
//   const [prevValue, setPrevValue] = React.useState(value);

//   React.useEffect(() => {
//     if (value !== prevValue) {
//       setPrevValue(value);
//     }
//   }, [value]);

//   return (
//     <div style={{ position: "relative", height: 50, overflow: "hidden" }}>
//       <AnimatePresence mode="wait">
//         <motion.div
//           key={value}
//           initial={{ y: 40, opacity: 0, scale: 0.8 }}
//           animate={{ y: 0, opacity: 1, scale: 1 }}
//           exit={{ y: -40, opacity: 0, scale: 0.9 }}
//           transition={{ duration: 0.5, ease: "easeOut" }}
//           style={{
//             position: "absolute",
//             width: "100%",
//             textAlign: "center",
//             fontSize: 40,
//             fontWeight: 700,
//             color: "#1890ff",
//           }}
//         >
//           {value.toLocaleString()}
//         </motion.div>
//       </AnimatePresence>
//     </div>
//   );
// };

// const HourlyProductionReport = () => {
//   const [lines, setLines] = useState([]);
//   const [operations, setOperations] = useState([]);
//   const [line, setLine] = useState("");
//   const [operation, setOperation] = useState("");
//   const [produced, setProduced] = useState(0);
//   const [target, setTarget] = useState(0);
//   const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [hourlyData, setHourlyData] = useState([]);
//   const [uniqueOperations, setUniqueOperations] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(
//     new Date().toISOString().split("T")[0]
    
//   );
// const efficiency = target > 0 ? ((produced / target) * 100).toFixed(1) : 0;

//   useEffect(() => {
//     const fetchDropdowns = async () => {
//       try {
//         const lineData = await ApiService.getLines();
//         const operationData = await ApiService.getOperations();
//         setLines(lineData);
//         setOperations(operationData);
//       } catch (err) {
//         message.error("Error loading dropdown data");
//       }
//     };
//     fetchDropdowns();
//   }, []);

//   // 🔹 Fetch summary data
//   const fetchReportData = async () => {
//     if (!line) return;
//     setLoading(true);
//     try {
//       const res = operation
//         ? await ApiService.getMasterOperationsCount(line, operation)
//         : await ApiService.getMasterOperationsCount(line);
//       if (res && res.status) {
//         const summary = res.data?.summary;
//         const stats = summary?.line_statistics?.[line];
//         if (stats) {
//           setProduced(stats["producedPCS(device_id)"] || 0);
//           setTarget(stats["target_pcs"] || 0);
//           setTableData(res.data?.master_operations || []);
//         } else {
//           setProduced(0);
//           setTarget(0);
//           setTableData([]);
//         }
//       }
//     } catch (e) {
//       console.error(e);
//       message.error("Failed to load data.");
//     } finally {
//       setLoading(false);
//     }
//   };

// const fetchHourlyData = async () => {
//   if (!line) return;
//   try {
//     const res = await ApiService.getHourlyDeviceCount(line, selectedDate);
//     if (res && res.hourly_data) {
//       const opNames = new Set();

//       // Collect all operation names from ALL hours
//       res.hourly_data.forEach((hour) =>
//         hour.devices.forEach((d) => opNames.add(d.op_name))
//       );

//       const allOps = Array.from(opNames);

//       const formatHour = (hourRange) => hourRange;

//       const addOffsetForDuplicates = (data, ops) => {
//         return data.map((row) => {
//           const seen = {};
//           ops.forEach((op) => {
//             if (row[op] !== 0) {
//               if (seen[row[op]]) {
//                 row[op] += 2;
//               }
//               seen[row[op]] = true;
//             }
//           });
//           return row;
//         });
//       };


// const formatted = res.hourly_data.map((hour) => {
//   const obj = {
//     hour_display: formatHour(hour.hour_display),
//   };

//   allOps.forEach((op) => (obj[op] = null));

//   hour.devices.forEach((d) => {
//     obj[d.op_name] = d.cumulative_count;
//   });

//   return obj;
// });

//       const adjustedData = addOffsetForDuplicates(formatted, allOps);
//       setHourlyData(adjustedData);
//       setUniqueOperations(allOps);
//     } else {
//       setHourlyData([]);
//       setUniqueOperations([]);
//     }
//   } catch (err) {
//     console.error("Hourly data error:", err);
//   }
// };


//   useEffect(() => {
//     if (!line) return;
//     fetchReportData();
//     fetchHourlyData();
//     const interval = setInterval(() => {
//       fetchReportData();
//       fetchHourlyData();
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [line, operation, selectedDate]);

//   // 🔹 Compact Bar chart data
//   const chartData =
//     tableData.map((item) => ({
//       name: item.op_name,
//       produced_count: item.operation_count,
//     })) || [];

//   // 🔹 Table Columns
//   const columns = [
//     { title: "Device ID", dataIndex: "device_id", align: "center" },
//     { title: "Operation Name", dataIndex: "op_name", align: "center" },
//     {
//       title: "Target Pcs",
//       dataIndex: "target_pcs",
//       align: "center",
//       render: (t) => t || 0,
//     },
//     {
//       title: "Produced Pcs",
//       dataIndex: "operation_count",
//       align: "center",
//       render: (t) => t || 0,
//     },
//   ];

//   // 🔹 Colors for each operation line
//   const getColor = (i) => {
//     const colors = [
//       "#1890ff",
//       "#52c41a",
//       "#faad14",
//       "#f5222d",
//       "#13c2c2",
//       "#722ed1",
//       "#eb2f96",
//       "#a0d911",
//       "#fa8c16",
//     ];
//     return colors[i % colors.length];
//   };

//   const handleLoad = () => {
//     if (!line) {
//       message.warning("Please select a Line!");
//       return;
//     }
//     fetchReportData();
//     fetchHourlyData();
//   };

//   return (
//     <div style={{ background: "#FFFFFFFF", minHeight: "100vh", padding: "6px" }}>
     
// <div
//   style={{
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: "25px",
//     flexWrap: "wrap",
//     background: "#fff",
//     padding: "15px 30px",
//     borderRadius: "10px",
//     boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
//     marginBottom: "30px",
//   }}
// >
//   {/* Select Line */}
//   <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//     <label
//       style={{
//         fontWeight: 600,
//         color: "#333",
//         whiteSpace: "nowrap",
//       }}
//     >
//       Select Line
//     </label>
//     <Select
//       placeholder="Select Line"
//       style={{ width: 180 }}
//       value={line}
//       onChange={setLine}
//       loading={!lines.length}
//       size="middle"
//     >
//       {lines.map((ln) => (
//         <Option key={ln} value={ln}>
//           {ln}
//         </Option>
//       ))}
//     </Select>
//   </div>

//   {/* Select Operation */}
//   <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//     <label
//       style={{
//         fontWeight: 600,
//         color: "#333",
//         whiteSpace: "nowrap",
//       }}
//     >
//       Select Operation
//     </label>
//     <Select
//       placeholder="Select Operation"
//       style={{ width: 220 }}
//       value={operation}
//       onChange={setOperation}
//       loading={!operations.length}
//       showSearch
//       optionFilterProp="children"
//       allowClear
//       size="middle"
//     >
//       {operations.map((op) => (
//         <Option key={op.op_id} value={op.op_id}>
//           {op.op_name}
//         </Option>
//       ))}
//     </Select>
//   </div>

//   {/* Load Button */}
//   <Button
//     type="primary"
//     icon={<SendOutlined />}
//     loading={loading}
//     onClick={handleLoad}
//     style={{
//       background: "#2150FD",
//       border: "none",
//       fontWeight: 600,
//       padding: "0 25px",
//       height: 38,
//     }}
//   >
//     Load
//   </Button>
// </div>



//       {/* 🔹 Summary Cards below Filters */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           gap: "40px",
//           flexWrap: "wrap",
//           marginTop: 25,
//         }}
//       >
//         <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
//     <Title level={5} style={cardTitle}>
//       Produced Pcs
//     </Title>
//     <motion.h1
//       key={produced}
//       initial={{ y: -10, opacity: 0 }}
//       animate={{ y: 0, opacity: 1 }}
//       transition={{ duration: 0.5 }}
//       style={{ color: "#1890ff", margin: 0, fontSize: "40px" }}
//     >
//       {produced}
//     </motion.h1>
//   </Card>

//           <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
//     <Title level={5} style={cardTitle}>
//       Target Pcs
//     </Title>
//     <motion.h1
//       key={target}
//       initial={{ y: -10, opacity: 0 }}
//       animate={{ y: 0, opacity: 1 }}
//       transition={{ duration: 0.5 }}
//       style={{ color: "#52c41a", margin: 0, fontSize: "40px" }}
//     >
//       {target}
//     </motion.h1>
//   </Card>
//          <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
//     <Title level={5} style={cardTitle}>
//       Efficiency %
//     </Title>
//     <motion.h1
//       key={efficiency}
//       initial={{ x: 50, opacity: 0 }}
//       animate={{ x: 0, opacity: 1 }}
//       transition={{ duration: 0.6 }}
//       style={{
//         color:
//           efficiency >= 100
//             ? "#52c41a"
//             : efficiency >= 80
//             ? "#faad14"
//             : "#f5222d",
//         margin: 0,
//         fontSize: "40px",
//       }}
//     >
//       {efficiency}%
//     </motion.h1>
//   </Card>
//       </div>

//       {/* 🔹 Tabs Section */}
//       <div
//         style={{
//           marginTop: 30,
//           background: "#fff",
//           borderRadius: 10,
//           boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//           padding: "20px",
//         }}
//       >
//         <Tabs defaultActiveKey="1" centered>
//           {/* Bar Chart */}
//           <TabPane
//             tab={
//               <span>
//                 <BarChartOutlined /> Overall Production
//               </span>
//             }
//             key="1"
//           >
//             <ResponsiveContainer width="100%" height={400}>
//               <BarChart
//                 data={chartData}
//                 margin={{ top: 20, right: 20, left: 0, bottom: 10 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//              <YAxis label={{ value: "Cumulative Produced Count", angle: -90, position: "insideLeft" }} />
// <Tooltip formatter={(val) => [val, "Cumulative Count"]} />
// <Legend formatter={(value) => `${value}`} />

//                 <Bar
//                   dataKey="produced_count"
//                   name="Produced Count"
//                   fill="#1890ff"
//                   barSize={45}
//                 >
//                   <LabelList
//                     dataKey="produced_count"
//                     position="top"
//                     fill="#000"
//                     fontSize={13}
//                   />
//                 </Bar>
//               </BarChart>
//             </ResponsiveContainer>
//           </TabPane>

//           {/* Multi-Line Chart */}
//           <TabPane
//             tab={
//               <span>
//                 <LineChartOutlined /> Hourly Production
//               </span>
//             }
//             key="2"
//           >
//             {/* Date only for line chart */}
//             <div style={{ marginBottom: 15, textAlign: "right" }}>
//               <label style={{ fontWeight: 600, marginRight: 10 }}>Select Date:</label>
//               <input
//                 type="date"
//                 value={selectedDate}
//                 onChange={(e) => setSelectedDate(e.target.value)}
//                 style={{
//                   padding: "4px 8px",
//                   borderRadius: 5,
//                   border: "1px solid #ccc",
//                 }}
//               />
//             </div>

//             <ResponsiveContainer width="100%" height={420}>
//               <LineChart data={hourlyData}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="hour_display" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 {uniqueOperations.map((op, i) => (
            
//                   <Line
//   key={op}
//   type="monotone"
//   dataKey={op}
//   stroke={getColor(i)}
//   strokeWidth={3}
//   connectNulls={false} // 👈 very important
//   dot={{ r: 3 }}
//   name={op}
// />

//                 ))}
//               </LineChart>
//             </ResponsiveContainer>
//           </TabPane>

//           {/* Summary Table */}
//           <TabPane
//             tab={
//               <span>
//                 <FileTextOutlined /> Summary
//               </span>
//             }
//             key="3"
//           >
//             <Spin spinning={loading}>
//               <Table
//                 dataSource={tableData}
//                 columns={columns}
//                 pagination={false}
//                 bordered
//                 rowKey="com_id"
//               />
//             </Spin>
//           </TabPane>
//         </Tabs>
//       </div>
//     </div>
//   );
// };

// // 🔹 Styles
// const labelStyle = { display: "block", fontWeight: 600, fontSize: 13, marginBottom: 3 };
// const cardStyle = {
//   background: "#fff",
//   borderRadius: 10,
//   boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//   textAlign: "center",
//   minWidth: 180,
// };
// const cardTitle = {
//   color: "#555",
//   fontWeight: 600,
//   marginBottom: 5,
//   textTransform: "uppercase",
// };

// export default HourlyProductionReport;
// import React, { useState, useEffect } from "react";
// import {
//   Select,
//   Button,
//   Card,
//   Typography,
//   Table,
//   message,
//   Spin,
//   Tabs,
// } from "antd";
// import {
//   SendOutlined,
//   BarChartOutlined,
//   LineChartOutlined,
//   FileTextOutlined,
// } from "@ant-design/icons";
// import {
//   BarChart,
//   Bar,
//   LineChart,
//   Line,
//   CartesianGrid,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   LabelList,
// } from "recharts";
// import ApiService from "../EOLReportApi/ReportApiService";
// import "antd/dist/reset.css";
// import { motion, AnimatePresence } from "framer-motion";

// const { Option } = Select;
// const { Title } = Typography;
// const { TabPane } = Tabs;

// const AnimatedCounter = ({ value }) => {
//   const [prevValue, setPrevValue] = React.useState(value);

//   React.useEffect(() => {
//     if (value !== prevValue) {
//       setPrevValue(value);
//     }
//   }, [value]);

//   return (
//     <div style={{ position: "relative", height: 50, overflow: "hidden" }}>
//       <AnimatePresence mode="wait">
//         <motion.div
//           key={value}
//           initial={{ y: 40, opacity: 0, scale: 0.8 }}
//           animate={{ y: 0, opacity: 1, scale: 1 }}
//           exit={{ y: -40, opacity: 0, scale: 0.9 }}
//           transition={{ duration: 0.5, ease: "easeOut" }}
//           style={{
//             position: "absolute",
//             width: "100%",
//             textAlign: "center",
//             fontSize: 40,
//             fontWeight: 700,
//             color: "#1890ff",
//           }}
//         >
//           {value.toLocaleString()}
//         </motion.div>
//       </AnimatePresence>
//     </div>
//   );
// };

// const HourlyProductionReport = () => {
//   const [lines, setLines] = useState([]);
//   const [operations, setOperations] = useState([]);
//   const [line, setLine] = useState("");
//   const [operation, setOperation] = useState("");
//   const [produced, setProduced] = useState(0);
//   const [target, setTarget] = useState(0);
//   const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [hourlyData, setHourlyData] = useState([]);
//   const [uniqueOperations, setUniqueOperations] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(
//     new Date().toISOString().split("T")[0]
//   );

//   const efficiency = target > 0 ? ((produced / target) * 100).toFixed(1) : 0;

//   useEffect(() => {
//     const fetchDropdowns = async () => {
//       try {
//         const lineData = await ApiService.getLines();
//         const operationData = await ApiService.getOperations();
//         setLines(lineData);
//         setOperations(operationData);
//       } catch (err) {
//         message.error("Error loading dropdown data");
//       }
//     };
//     fetchDropdowns();
//   }, []);

//   // 🔹 Fetch summary data
//   const fetchReportData = async () => {
//     if (!line) return;
//     setLoading(true);
//     try {
//       const res = operation
//         ? await ApiService.getMasterOperationsCount(line, operation, selectedDate)
//         : await ApiService.getMasterOperationsCount(line, "", selectedDate);

//       if (res && res.status) {
//         const summary = res.data?.summary;
//         const stats = summary?.line_statistics?.[line];
//         if (stats) {
//           setProduced(parseInt(stats["producedPCS(device_id)"] || 0));
//           setTarget(parseInt(stats["target_pcs"] || 0));
//         } else {
//           setProduced(0);
//           setTarget(0);
//         }

//         const parsedOps =
//           res.data?.master_operations?.map((item) => ({
//             ...item,
//             target_pcs: parseInt(item.target_pcs || 0),
//             operation_count: parseInt(item.operation_count || 0),
//             "Projected Production": parseInt(
//               parseFloat(item["Projected Production"] || 0)
//             ),
//             "Real time Target": parseInt(
//               parseFloat(item["Real time Target"] || 0)
//             ),
//           })) || [];

//         setTableData(parsedOps);
//       }
//     } catch (e) {
//       console.error(e);
//       message.error("Failed to load data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchHourlyData = async () => {
//     if (!line) return;
//     try {
//       const res = await ApiService.getHourlyDeviceCount(line, selectedDate);
//       if (res && res.hourly_data) {
//         const opNames = new Set();
//         res.hourly_data.forEach((hour) =>
//           hour.devices.forEach((d) => opNames.add(d.op_name))
//         );
//         const allOps = Array.from(opNames);

//         const formatted = res.hourly_data.map((hour) => {
//           const obj = { hour_display: hour.hour_display };
//           allOps.forEach((op) => (obj[op] = null));
//           hour.devices.forEach((d) => {
//             obj[d.op_name] = d.cumulative_count;
//           });
//           return obj;
//         });

//         setHourlyData(formatted);
//         setUniqueOperations(allOps);
//       } else {
//         setHourlyData([]);
//         setUniqueOperations([]);
//       }
//     } catch (err) {
//       console.error("Hourly data error:", err);
//     }
//   };

//   useEffect(() => {
//     if (!line) return;
//     fetchReportData();
//     fetchHourlyData();
//     const interval = setInterval(() => {
//       fetchReportData();
//       fetchHourlyData();
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [line, operation, selectedDate]);

//   const getColor = (i) => {
//     const colors = [
//       "#1890ff",
//       "#52c41a",
//       "#faad14",
//       "#f5222d",
//       "#13c2c2",
//       "#722ed1",
//       "#eb2f96",
//       "#a0d911",
//       "#fa8c16",
//     ];
//     return colors[i % colors.length];
//   };

//   const handleLoad = () => {
//     if (!line) {
//       message.warning("Please select a Line!");
//       return;
//     }
//     fetchReportData();
//     fetchHourlyData();
//   };

//   const columns = [
//     { title: "Device ID", dataIndex: "device_id", align: "center" },
//     { title: "Operation Name", dataIndex: "op_name", align: "center" },
//     { title: "Target Pcs", dataIndex: "target_pcs", align: "center" },
//     { title: "Produced Pcs", dataIndex: "operation_count", align: "center" },
//     {
//       title: "Projected Production",
//       dataIndex: "Projected Production",
//       align: "center",
//     },
//     {
//       title: "Real Time Target",
//       dataIndex: "Real time Target",
//       align: "center",
//     },
//   ];

//   return (
//     <div style={{ background: "#FFFFFFFF", minHeight: "100vh", padding: "6px" }}>
//       {/* 🔹 Filters */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: "25px",
//           flexWrap: "wrap",
//           background: "#fff",
//           padding: "15px 30px",
//           borderRadius: "10px",
//           boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
//           marginBottom: "30px",
//         }}
//       >
//         {/* Select Line */}
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           <label
//             style={{
//               fontWeight: 600,
//               color: "#333",
//               whiteSpace: "nowrap",
//             }}
//           >
//             Select Line
//           </label>
//           <Select
//             placeholder="Select Line"
//             style={{ width: 180 }}
//             value={line}
//             onChange={setLine}
//             loading={!lines.length}
//             size="middle"
//           >
//             {lines.map((ln) => (
//               <Option key={ln} value={ln}>
//                 {ln}
//               </Option>
//             ))}
//           </Select>
//         </div>

//         {/* Select Operation */}
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           <label
//             style={{
//               fontWeight: 600,
//               color: "#333",
//               whiteSpace: "nowrap",
//             }}
//           >
//             Select Operation
//           </label>
//           <Select
//             placeholder="Select Operation"
//             style={{ width: 220 }}
//             value={operation}
//             onChange={setOperation}
//             loading={!operations.length}
//             showSearch
//             optionFilterProp="children"
//             allowClear
//             size="middle"
//           >
//             {operations.map((op) => (
//               <Option key={op.op_id} value={op.op_id}>
//                 {op.op_name}
//               </Option>
//             ))}
//           </Select>
//         </div>

//         {/* Select Date */}
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           <label
//             style={{
//               fontWeight: 600,
//               color: "#333",
//               whiteSpace: "nowrap",
//             }}
//           >
//             Select Date
//           </label>
//           <input
//             type="date"
//             value={selectedDate}
//             onChange={(e) => setSelectedDate(e.target.value)}
//             style={{
//               padding: "4px 8px",
//               borderRadius: 5,
//               border: "1px solid #ccc",
//             }}
//           />
//         </div>

//         {/* Load Button */}
//         <Button
//           type="primary"
//           icon={<SendOutlined />}
//           loading={loading}
//           onClick={handleLoad}
//           style={{
//             background: "#2150FD",
//             border: "none",
//             fontWeight: 600,
//             padding: "0 25px",
//             height: 38,
//           }}
//         >
//           Load
//         </Button>
//       </div>

//       {/* 🔹 Summary Cards */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           gap: "40px",
//           flexWrap: "wrap",
//           marginTop: 25,
//         }}
//       >
//         <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
//           <Title level={5} style={cardTitle}>
//             Produced Pcs
//           </Title>
//           <motion.h1
//             key={produced}
//             initial={{ y: -10, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ duration: 0.5 }}
//             style={{ color: "#1890ff", margin: 0, fontSize: "40px" }}
//           >
//             {produced}
//           </motion.h1>
//         </Card>

//         <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
//           <Title level={5} style={cardTitle}>
//             Target Pcs
//           </Title>
//           <motion.h1
//             key={target}
//             initial={{ y: -10, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ duration: 0.5 }}
//             style={{ color: "#52c41a", margin: 0, fontSize: "40px" }}
//           >
//             {target}
//           </motion.h1>
//         </Card>

//         <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
//           <Title level={5} style={cardTitle}>
//             Efficiency %
//           </Title>
//           <motion.h1
//             key={efficiency}
//             initial={{ x: 50, opacity: 0 }}
//             animate={{ x: 0, opacity: 1 }}
//             transition={{ duration: 0.6 }}
//             style={{
//               color:
//                 efficiency >= 100
//                   ? "#52c41a"
//                   : efficiency >= 80
//                   ? "#faad14"
//                   : "#f5222d",
//               margin: 0,
//               fontSize: "40px",
//             }}
//           >
//             {efficiency}%
//           </motion.h1>
//         </Card>
//       </div>

//       {/* 🔹 Tabs Section */}
//       <div
//         style={{
//           marginTop: 30,
//           background: "#fff",
//           borderRadius: 10,
//           boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//           padding: "20px",
//         }}
//       >
//         <Tabs defaultActiveKey="1" centered>
//           {/* 🔹 Stacked Bar Chart */}
//           <TabPane
//             tab={
//               <span>
//                 <BarChartOutlined /> Overall Production
//               </span>
//             }
//             key="1"
//           >
// <ResponsiveContainer width="100%" height={420}>
//   <BarChart
//     data={tableData}
//     margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
//     barCategoryGap="20%"
//   >
//     <CartesianGrid strokeDasharray="3 3" />
//     <XAxis dataKey="op_name" />
//     <YAxis domain={[0, "dataMax"]} allowDecimals={false} />
//     <Tooltip
//   formatter={(value, name) => {
//     const labelMap = {
//       target_pcs: "Day Target (Pcs)",
//       "Real time Target": "Real Time Target",
//       "Projected Production": "Projected Production",
//       operation_count: "Real Time Production",
//     };
//     return [value, labelMap[name] || name];
//   }}
// />


//     <Legend />

//     {/* === PLAN GROUP === */}
//     {/* 🟨 Target Pcs */}
//     <Bar
//       dataKey="target_pcs"
//       fill="#faad14"
//       name="Target Pcs"
//       barSize={150}
//       stackId="plan"
//     >
//       <LabelList
//         dataKey="target_pcs"
//         position="insideTop"
//         fill="#000"
//         fontSize={12}
//       />
//     </Bar>

//     {/* 🟦 Projected Production */}
//     <Bar
//       dataKey="Projected Production"
//       fill="#1890ff"
//       name="Projected Production"
//       barSize={150}
//       stackId="plan"
//     >
//       <LabelList
//         dataKey="Projected Production"
//         position="insideTop"
//         fill="#fff"
//         fontSize={12}
//         formatter={(val) => Math.round(val)}
//       />
//     </Bar>

//     {/* === ACTUAL GROUP === */}
//     {/* 🟥 Real Time Target */}
//     <Bar
//       dataKey="Real time Target"
//       fill="#f5222d"
//       name="Real Time Target"
//       barSize={150}
//       stackId="actual"
//     >
//       <LabelList
//         dataKey="Real time Target"
//         position="insideTop"
//         fill="#fff"
//         fontSize={12}
//         formatter={(val) => Math.round(val)}
//       />
//     </Bar>

//     {/* 🟩 Operation Count */}
//     <Bar
//       dataKey="operation_count"
//       fill="#52c41a"
//       name="Operation Count"
//       barSize={150}
//       stackId="actual"
//     >
//       <LabelList
//         dataKey="operation_count"
//         position="insideTop"
//         fill="#fff"
//         fontSize={12}
//       />
//     </Bar>
//   </BarChart>
// </ResponsiveContainer>





//           </TabPane>

//           {/* 🔹 Hourly Production */}
//           <TabPane
//             tab={
//               <span>
//                 <LineChartOutlined /> Hourly Production
//               </span>
//             }
//             key="2"
//           >
//            <ResponsiveContainer width="100%" height={420}>
//   <LineChart
//     data={hourlyData}
//     margin={{ top: 30, right: 50, left: 20, bottom: 20 }} // ✅ Added right margin
//   >
//     <CartesianGrid strokeDasharray="3 3" />
//     <XAxis dataKey="hour_display" />
//     <YAxis />
//     <Tooltip />
//     <Legend />

//     {uniqueOperations.map((op, i) => (
//       <Line
//         key={op}
//         type="monotone"
//         dataKey={op}
//         stroke={getColor(i)}
//         strokeWidth={3}
//         connectNulls={false}
//         dot={{ r: 4 }}
//         name={op}
//       >
//         <LabelList
//           dataKey={op}
//           position="top"
//           offset={10}  // ✅ Moves label slightly inside
//           fontSize={12}
//           fill="#000"
//         />
//       </Line>
//     ))}
//   </LineChart>
// </ResponsiveContainer>

//           </TabPane>

//           {/* 🔹 Summary Table */}
//           <TabPane
//             tab={
//               <span>
//                 <FileTextOutlined /> Summary
//               </span>
//             }
//             key="3"
//           >
//             <Spin spinning={loading}>
//               <Table
//                 dataSource={tableData}
//                 columns={columns}
//                 pagination={false}
//                 bordered
//                 rowKey="com_id"
//               />
//             </Spin>
//           </TabPane>
//         </Tabs>
//       </div>
//     </div>
//   );
// };

// // 🔹 Styles
// const cardStyle = {
//   background: "#fff",
//   borderRadius: 10,
//   boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//   textAlign: "center",
//   minWidth: 180,
// };
// const cardTitle = {
//   color: "#555",
//   fontWeight: 600,
//   marginBottom: 5,
//   textTransform: "uppercase",
// };

// export default HourlyProductionReport;
import React, { useState, useEffect } from "react";
import {
  Select,
  Button,
  Card,
  Typography,
  Table,
  message,
  Spin,
  Tabs,
} from "antd";
import {
  SendOutlined,
  BarChartOutlined,
  LineChartOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import ApiService from "../EOLReportApi/ReportApiService";
import "antd/dist/reset.css";
import { motion, AnimatePresence } from "framer-motion";

const { Option } = Select;
const { Title } = Typography;
const { TabPane } = Tabs;

const HourlyProductionReport = () => {
  const [lines, setLines] = useState([]);
  const [operations, setOperations] = useState([]);
  const [line, setLine] = useState("");
  const [operation, setOperation] = useState("");
  const [produced, setProduced] = useState(0);
  const [target, setTarget] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hourlyData, setHourlyData] = useState([]);
  const [uniqueOperations, setUniqueOperations] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const efficiency = target > 0 ? ((produced / target) * 100).toFixed(1) : 0;

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const lineData = await ApiService.getLines();
        const operationData = await ApiService.getOperations();
        setLines(lineData);
        setOperations(operationData);
      } catch (err) {
        message.error("Error loading dropdown data");
      }
    };
    fetchDropdowns();
  }, []);

  const fetchReportData = async () => {
    if (!line) return;
    setLoading(true);
    try {
      const res = operation
        ? await ApiService.getMasterOperationsCount(line, operation, selectedDate)
        : await ApiService.getMasterOperationsCount(line, "", selectedDate);

      if (res && res.status) {
        const summary = res.data?.summary;
        const stats = summary?.line_statistics?.[line];
        if (stats) {
          setProduced(parseInt(stats["producedPCS(device_id)"] || 0));
          setTarget(parseInt(stats["target_pcs"] || 0));
        } else {
          setProduced(0);
          setTarget(0);
        }

        const parsedOps =
          res.data?.master_operations?.map((item) => ({
            ...item,
            target_pcs: parseInt(item.target_pcs || 0),
            operation_count: parseInt(item.operation_count || 0),
            "Projected Production": parseInt(
              parseFloat(item["Projected Production"] || 0)
            ),
            "Real time Target": parseInt(
              parseFloat(item["Real time Target"] || 0)
            ),
          })) || [];

        setTableData(parsedOps);
      }
    } catch (e) {
      console.error(e);
      message.error("Failed to load data.");
    } finally {
      setLoading(false);
    }
  };

  const fetchHourlyData = async () => {
    if (!line) return;
    try {
      const res = await ApiService.getHourlyDeviceCount(line, selectedDate);
      if (res && res.hourly_data) {
        const opNames = new Set();
        res.hourly_data.forEach((hour) =>
          hour.devices.forEach((d) => opNames.add(d.op_name))
        );
        const allOps = Array.from(opNames);

        const formatted = res.hourly_data.map((hour) => {
          const obj = { hour_display: hour.hour_display };
          allOps.forEach((op) => (obj[op] = null));
          hour.devices.forEach((d) => {
            obj[d.op_name] = d.cumulative_count;
          });
          return obj;
        });

        setHourlyData(formatted);
        setUniqueOperations(allOps);
      } else {
        setHourlyData([]);
        setUniqueOperations([]);
      }
    } catch (err) {
      console.error("Hourly data error:", err);
    }
  };

  useEffect(() => {
    if (!line) return;
    fetchReportData();
    fetchHourlyData();
    const interval = setInterval(() => {
      fetchReportData();
      fetchHourlyData();
    }, 5000);
    return () => clearInterval(interval);
  }, [line, operation, selectedDate]);

  const getColor = (i) => {
    const colors = [
      "#1890ff",
      "#52c41a",
      "#faad14",
      "#f5222d",
      "#13c2c2",
      "#722ed1",
      "#eb2f96",
      "#a0d911",
      "#fa8c16",
    ];
    return colors[i % colors.length];
  };

  const handleLoad = () => {
    if (!line) {
      message.warning("Please select a Line!");
      return;
    }
    fetchReportData();
    fetchHourlyData();
  };

  const columns = [
    { title: "Device ID", dataIndex: "device_id", align: "center" },
    { title: "Operation Name", dataIndex: "op_name", align: "center" },
    { title: "Day Target", dataIndex: "target_pcs", align: "center" },
    { title: "Real Time Production", dataIndex: "operation_count", align: "center" },
    {
      title: "Projected Production",
      dataIndex: "Projected Production",
      align: "center",
    },
    {
      title: "Real Time Target",
      dataIndex: "Real time Target",
      align: "center",
    },
  ];

  // 🔹 Label rename map
  const labelMap = {
    target_pcs: "Day Target",
    "Real time Target": "Real Time Target",
    "Projected Production": "Projected Production",
    operation_count: "Real Time Production",
  };

  return (
    <div style={{ background: "#FFFFFFFF", minHeight: "100vh", padding: "6px" }}>
      {/* Filters */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "25px",
          flexWrap: "wrap",
          background: "#fff",
          padding: "15px 30px",
          borderRadius: "10px",
          boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
          marginBottom: "30px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <label style={{ fontWeight: 600, color: "#333" }}>Select Line</label>
          <Select
            placeholder="Select Line"
            style={{ width: 180 }}
            value={line}
            onChange={setLine}
            loading={!lines.length}
            size="middle"
          >
            {lines.map((ln) => (
              <Option key={ln} value={ln}>
                {ln}
              </Option>
            ))}
          </Select>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <label style={{ fontWeight: 600, color: "#333" }}>Select Operation</label>
          <Select
            placeholder="Select Operation"
            style={{ width: 220 }}
            value={operation}
            onChange={setOperation}
            loading={!operations.length}
            showSearch
            optionFilterProp="children"
            allowClear
            size="middle"
          >
            {operations.map((op) => (
              <Option key={op.op_id} value={op.op_id}>
                {op.op_name}
              </Option>
            ))}
          </Select>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <label style={{ fontWeight: 600, color: "#333" }}>Select Date</label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            style={{
              padding: "4px 8px",
              borderRadius: 5,
              border: "1px solid #ccc",
            }}
          />
        </div>

        <Button
          type="primary"
          icon={<SendOutlined />}
          loading={loading}
          onClick={handleLoad}
          style={{
            background: "#2150FD",
            border: "none",
            fontWeight: 600,
            padding: "0 25px",
            height: 38,
          }}
        >
          Load
        </Button>
      </div>

      {/* Summary Cards */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "40px",
          flexWrap: "wrap",
          marginTop: 25,
        }}
      >
        <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
          <Title level={5} style={cardTitle}>
            Produced Pcs
          </Title>
          <motion.h1
            key={produced}
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            style={{ color: "#1890ff", margin: 0, fontSize: "40px" }}
          >
            {produced}
          </motion.h1>
        </Card>

        <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
          <Title level={5} style={cardTitle}>
            Target Pcs
          </Title>
          <motion.h1
            key={target}
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            style={{ color: "#52c41a", margin: 0, fontSize: "40px" }}
          >
            {target}
          </motion.h1>
        </Card>

        <Card style={cardStyle} bodyStyle={{ padding: "20px 30px" }}>
          <Title level={5} style={cardTitle}>
            Efficiency %
          </Title>
          <motion.h1
            key={efficiency}
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
            style={{
              color:
                efficiency >= 100
                  ? "#52c41a"
                  : efficiency >= 80
                  ? "#faad14"
                  : "#f5222d",
              margin: 0,
              fontSize: "40px",
            }}
          >
            {efficiency}%
          </motion.h1>
        </Card>
      </div>

      {/* Tabs Section */}
      <div
        style={{
          marginTop: 30,
          background: "#fff",
          borderRadius: 10,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          padding: "20px",
        }}
      >
        <Tabs defaultActiveKey="1" centered>
          {/* === Overall Production === */}
          <TabPane
            tab={
              <span>
                <BarChartOutlined /> Overall Production
              </span>
            }
            key="1"
          >
            <ResponsiveContainer width="100%" height={420}>
              <BarChart
                data={tableData}
                margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
                barCategoryGap="20%"
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="op_name" />
                <YAxis domain={[0, "dataMax"]} allowDecimals={false} />
              <Tooltip
  content={({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const order = [
        "target_pcs",
        "Real time Target",
        "Projected Production",
        "operation_count",
      ];

      const sorted = payload.sort(
        (a, b) => order.indexOf(a.dataKey) - order.indexOf(b.dataKey)
      );

      const labelMap = {
        target_pcs: { label: "Day Target", color: "#faad14" },
        "Real time Target": { label: "Real Time Target", color: "#f5222d" },
        "Projected Production": { label: "Projected Production", color: "#1890ff" },
        operation_count: { label: "Real Time Production", color: "#52c41a" },
      };

      return (
        <div
          style={{
            background: "rgba(255,255,255,0.95)",
            borderRadius: "10px",
            padding: "10px 15px",
            boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
            border: "1px solid #eee",
            minWidth: "200px",
          }}
        >
          <div
            style={{
              fontWeight: 600,
              textAlign: "center",
              marginBottom: 6,
              color: "#000",
            }}
          >
            {label}
          </div>
          {sorted.map((entry) => {
            const meta = labelMap[entry.dataKey];
            return (
              <div
                key={entry.dataKey}
                style={{
                  color: meta.color,
                  fontWeight: 500,
                  marginBottom: 2,
                  fontSize: 14,
                }}
              >
                {meta.label} : {entry.value}
              </div>
            );
          })}
        </div>
      );
    }
    return null;
  }}
/>

                <Legend
                  formatter={(value) => labelMap[value] || value}
                />

                {/* 🟨 Day Target */}
                <Bar dataKey="target_pcs" fill="#faad14" barSize={150} stackId="plan">
                  <LabelList dataKey="target_pcs" position="insideTop" fill="#000" />
                </Bar>

                {/* 🟦 Projected */}
                <Bar dataKey="Projected Production" fill="#1890ff" barSize={150} stackId="plan">
                  <LabelList dataKey="Projected Production" position="insideTop" fill="#fff" />
                </Bar>

                {/* 🟥 Real Time Target */}
                <Bar dataKey="Real time Target" fill="#f5222d" barSize={150} stackId="actual">
                  <LabelList dataKey="Real time Target" position="insideTop" fill="#fff" />
                </Bar>

                {/* 🟩 Real Time Production */}
                <Bar dataKey="operation_count" fill="#52c41a" barSize={150} stackId="actual">
                  <LabelList dataKey="operation_count" position="insideTop" fill="#fff" />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </TabPane>

          {/* === Hourly Production === */}
          <TabPane
            tab={
              <span>
                <LineChartOutlined /> Hourly Production
              </span>
            }
            key="2"
          >
            <ResponsiveContainer width="100%" height={420}>
              <LineChart
                data={hourlyData}
                margin={{ top: 30, right: 50, left: 20, bottom: 20 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="hour_display" />
                <YAxis />
                <Tooltip />
                <Legend />
                {uniqueOperations.map((op, i) => (
                  <Line
                    key={op}
                    type="monotone"
                    dataKey={op}
                    stroke={getColor(i)}
                    strokeWidth={3}
                    connectNulls={false}
                    dot={{ r: 4 }}
                    name={op}
                  >
                    <LabelList
                      dataKey={op}
                      position="top"
                      offset={10}
                      fontSize={12}
                      fill="#000"
                    />
                  </Line>
                ))}
              </LineChart>
            </ResponsiveContainer>
          </TabPane>

          {/* === Summary Table === */}
          <TabPane
            tab={
              <span>
                <FileTextOutlined /> Summary
              </span>
            }
            key="3"
          >
            <Spin spinning={loading}>
              <Table
                dataSource={tableData}
                columns={columns}
                pagination={false}
                bordered
                rowKey="com_id"
              />
            </Spin>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

const cardStyle = {
  background: "#fff",
  borderRadius: 10,
  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  textAlign: "center",
  minWidth: 180,
};
const cardTitle = {
  color: "#555",
  fontWeight: 600,
  marginBottom: 5,
  textTransform: "uppercase",
};

export default HourlyProductionReport;
